<template>
  <v-container fluid>
    <v-sheet rounded="lg" class="pa-4">
      <h2 class="mb-4 font-weight-bold" :style="{ color: color.primaryVariant }">
        Mis Facturas
      </h2>

      <v-tabs v-model="tab" :color="color.primaryVariant">
        <v-tab>Repositorio</v-tab>
        <v-tab>Análisis</v-tab>
      </v-tabs>

      <v-tabs-items v-model="tab" class="mt-4">
        <v-tab-item>
          <InvoiceRepository />
        </v-tab-item>
        <v-tab-item>
          <InvoiceCharts />
        </v-tab-item>
      </v-tabs-items>
    </v-sheet>
  </v-container>
</template>

<script>
import { colors } from "@/constants/colors";
import InvoiceRepository from "./InvoiceRepository.vue";
import InvoiceCharts from "./InvoiceCharts.vue";

export default {
  name: "MisFacturas",
  components: { InvoiceRepository, InvoiceCharts },
  data() {
    return {
      tab: 0,
      color: colors,
    };
  },
};
</script>
